export default {
  common: {
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    loading: 'Laden...',
    loadMore: 'Mehr laden',
    noMore: 'Keine mehr',
    retry: 'Wiederholen',
    back: 'Zurück',
    next: 'Weiter',
    prev: 'Zurück',
    submit: 'Absenden',
    reset: 'Zurücksetzen',
    search: 'Suchen',
    filter: 'Filtern',
    sort: 'Sortieren',
    refresh: 'Aktualisieren',
    complete: 'Fertig',
    skip: 'Überspringen',
    download: 'Herunterladen',
  },
  nav: {
    discover: 'Startseite',
    message: 'Nachrichten',
    store: 'Shop',
    mine: 'Ich',
    recommend: 'Empfohlen',
  },
  scene: {
    changeScene: 'Szene wechseln',
    seeAll: 'Alle anzeigen',
    putAway: 'Einklappen',
    selectScene: 'Diese Szene auswählen',
    selected: 'Ausgewählt',
    sceneIndex: 'Szene {num}',
  },
  home: {
    title: 'Rollenspiel-Welt',
    subtitle: 'Beginne deine Geschichte',
    startGame: 'Spiel starten',
    continueGame: 'Fortsetzen',
    newGame: 'Neues Spiel',
    gameLibrary: 'Bibliothek',
    featured: 'Empfohlen',
    popular: 'Beliebt',
    recent: 'Kürzlich',
    searchHistory: 'Suche',
    search: 'Rollen suchen...',
    noData: 'Keine Daten',
    noMoreData: 'Keine weiteren Daten',
    noNetwork: 'Kein Netzwerk',
    pleaseSelectFilter: 'Bitte wählen Sie die Filterbedingungen',
  },
  user: {
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    profile: 'Profil',
    avatar: 'Avatar',
    nickname: 'Spitzname',
    email: 'E-Mail',
    phone: 'Telefon',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    oldPassword: 'Altes Passwort',
    newPassword: 'Neues Passwort',
    forgotPassword: 'Passwort vergessen',
    changePassword: 'Passwort ändern',
    bindPhone: 'Telefon binden',
    verifyCode: 'Bestätigungscode',
    sendCode: 'Code senden',
    level: 'Level',
    experience: 'Erfahrung',
    achievement: 'Erfolg',
    history: 'Verlauf'
  },
  game: {
    character: 'Charakter',
    story: 'Geschichte',
    chapter: 'Kapitel',
    scene: 'Szene',
    dialogue: 'Dialog',
    choice: 'Auswahl',
    inventory: 'Inventar',
    achievement: 'Erfolg',
    save: 'Spiel speichern',
    load: 'Spiel laden',
    restart: 'Neustart',
    pause: 'Pause',
    resume: 'Fortsetzen',
    auto: 'Auto',
    speed: 'Geschwindigkeit',
    volume: 'Lautstärke',
    settings: 'Spieleinstellungen'
  },
  message: {
    success: 'Erfolg',
    error: 'Fehler',
    warning: 'Warnung',
    info: 'Info',
    networkError: 'Netzwerkfehler',
    serverError: 'Serverfehler',
    loginSuccess: 'Registrierung erfolgreich',
    loginFailed: 'Registrierung fehlgeschlagen',
    logoutSuccess: 'Abmeldung erfolgreich',
    saveSuccess: 'Erfolgreich gespeichert',
    saveFailed: 'Speichern fehlgeschlagen',
    deleteConfirm: 'Löschen bestätigen?',
    operationConfirm: 'Vorgang bestätigen?',
    noNewsYet: 'Noch keine Nachrichten',
    deleteSuccess: 'Erfolgreich gelöscht',
    deleteFailed: 'Löschen fehlgeschlagen',
    deleteMessage: 'Möchten Sie diese Nachricht wirklich löschen? Dies kann nicht rückgängig gemacht werden!',
    delete: 'Löschen',
    deleting: 'Wird gelöscht...',
    noMoreData: 'Keine weiteren Nachrichten',
    downloading: 'Wird heruntergeladen...',
    downloadSuccess: 'Erfolgreich heruntergeladen',
    downloadFailed: 'Download fehlgeschlagen',
    copySuccess: 'Erfolgreich kopiert',
    copyFailed: 'Kopieren fehlgeschlagen',
    reportSuccess: 'Erfolgreich gemeldet',
    reportFailed: 'Meldung fehlgeschlagen',
    translating: 'Wird übersetzt...',
    translateSuccess: 'Übersetzung erfolgreich',
    translateFailed: 'Übersetzung fehlgeschlagen',
    noMoreMessages: 'Keine weiteren Nachrichten',
    loading_more: 'Wird geladen...',
    pleaseWaitForReply: 'Bitte warten Sie auf die Antwort, bevor Sie löschen',
    pleaseWaitForReplyCurrent: 'Bitte warten Sie auf die Antwort der aktuellen Nachricht',
    chat_placeholder: 'Was möchten Sie sagen...',
    setAsBackdropConfirm: 'Als Hintergrund festlegen',
    setAsBackdropMessage: 'Möchten Sie dieses Bild wirklich als Hintergrund festlegen?',
    sendFailed: 'Senden fehlgeschlagen',
    sending: 'Wird gesendet...',
    introNoYet: 'Noch keine Einleitung. Chatten Sie und finden Sie es selbst heraus.',
    introLabel: 'Intro:',
    thinking: 'Denken',
    think: 'Denk',
    translate: 'Übersetzen',
    pleaseUnlock: 'Bitte entsperren',
    tryAgain: 'Erneut versuchen',
    create: 'Erstellen',
    free: 'Kostenlos',
    video: 'Video',
    chatMateTyping: 'Dein Chat-Partner tippt gerade...',
    aiAssistant: 'KI-Assistent',
    imageFailed: 'Bild konnte nicht erstellt werden',
    generatingImage: 'Bitte warten Sie auf die Bilderstellung',
    switchSceneSuccess: 'Szene erfolgreich gewechselt',
    switchSceneFailed: 'Szenenwechsel fehlgeschlagen',
    switchingScene: 'Szene wird gewechselt...',
    perMessage: '/Nachricht',
    allChat: 'Alle Chats',
    like: 'Gefällt mir',
    saving: 'Wird gespeichert...',
    saved: 'Gespeichert',
    placeholderBlur: 'Was möchten Sie sagen...',
    placeholderFocus: 'Platzieren Sie Aktionen oder Szenendetails innerhalb von **, um den Chat zum Leben zu erwecken.',
    successfulSwitch: 'Erfolgreich gewechselt',
    setting: 'Wird eingerichtet...',
    uploading: 'Wird hochgeladen...',
    purchaseSuccessful: 'Kauf erfolgreich',
    processing: 'Wird verarbeitet...',
    gettingReward: 'Belohnung wird abgerufen...',
    checkIn: 'Einchecken...',
    deleteHistory: 'Verlauf löschen',
    openingRemarksTitle: 'Sag hallo～',
  },
  success: {
    refreshSuccess: 'Erfolgreich aktualisiert',
    copiedToClipboard: 'In die Zwischenablage kopiert',
    saved: 'Gespeichert',
    uploadSuccess: 'Hochgeladen',
    switchSuccess: 'Erfolgreich gewechselt',
    thankYouPurchase: 'Vielen Dank für Ihren Einkauf',
  },
  error: {
    notFound: 'Seite nicht gefunden',
    networkError: 'Netzwerkfehler',
    serverError: 'Serverfehler',
    permissionDenied: 'Zugriff verweigert',
    goHome: 'Zur Startseite',
    tryAgain: 'Erneut versuchen',
    uploadFailed: 'Hochladen fehlgeschlagen',
    saveFailed: 'Speichern fehlgeschlagen',
    translationFailed: 'Übersetzung fehlgeschlagen',
    generateImageFailed: 'Bild konnte nicht erstellt werden',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    description: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    goHome: 'Zur Startseite',
    goBack: 'Zurück'
  },
  settings: {
    language: 'Sprache',
    theme: 'Design',
    notification: 'Benachrichtigungen',
    privacy: 'Datenschutz',
    security: 'Sicherheit',
    about: 'Über',
    version: 'Version',
    checkUpdate: 'Nach Updates suchen',
    clearCache: 'Cache leeren',
    systemNotification: 'Systembenachrichtigung',
    termsOfService: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie',
    title: 'Einstellungen',
    editProfile: 'Profil bearbeiten',
    faq: 'Häufig gestellte Fragen',
    termsOfUse: 'Nutzungsbedingungen',
    aboutAccount: 'Über das Konto',
    deleteAccount: 'Konto löschen',
    logOut: 'Abmelden',
    logOutTitle: 'Abmelden',
    logOutMessage: 'Nach dem Abmelden müssen Sie sich erneut anmelden, um Ihr Konto wieder zu verwenden. Sind Sie sicher, dass Sie sich abmelden möchten?',
    confirm: 'Bestätigen',
    deleteAccountTitle: 'Konto löschen',
    deleteAccountMessage: 'Das Löschen Ihres Kontos löscht alle Ihre Daten und Informationen und kann nicht rückgängig gemacht werden. Löschen bestätigen?',
    deletingAccount: 'Konto wird gelöscht...',
    accountDeleted: 'Konto erfolgreich gelöscht',
    cacheTitle: 'Cache leeren',
    cacheMessage: 'App-Cache wird geleert, Chatverläufe und Chatrollen werden nicht gelöscht',
    cleaning: 'Wird geleert',
    cleaningComplete: 'Leeren abgeschlossen',
  },
  profile: {
    title: 'Profil bearbeiten',
    yourAvatar: 'Ihr Avatar',
    whatCallMe: 'Was soll die KI mich nennen',
    yourName: 'Ihr Name',
    yourAge: 'Ihr Alter',
    race: 'Rasse',
    pleaseSelect: 'Bitte auswählen',
    yourWeight: 'Ihr Gewicht',
    yourHeight: 'Ihre Größe',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    neutral: 'Neutral',
    hobby: 'Hobby',
    pleaseEnter: 'Bitte eingeben...',
    favoriteFood: 'Lieblingsessen',
    yourCharacter: 'Ihr Charakter',
    fantasyAboutOtherHalf: 'Phantasie über Ihren Partner',
    uploading: 'Wird hochgeladen...',
    enterName: 'Bitte geben Sie Ihren Namen ein',
  },
  report: {
    title: 'Melden',
    chooseReact: 'Wählen Sie, was Sie melden möchten...',
    other: 'Andere',
    placeholder: 'Was möchten Sie sagen...',
    submit: 'Absenden',
    pleaseEnterContent: 'Bitte geben Sie den Inhalt ein',
  },
  edit: {
    placeholder: 'Nachricht bearbeiten...',
    cancel: 'Abbrechen',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
  },
  firstConfirmName: {
    canYouTellMeName: 'Können Sie mir Ihren Namen sagen? So kann ich Sie besser ansprechen!',
    yourName: 'Ihr Name',
    confirm: 'Bestätigen',
  },
  toast: {
    translating: 'Wird übersetzt...',
    translate: 'Übersetzen',
    translationFailed: 'Übersetzung fehlgeschlagen',
    translationUnlocked: 'Übersetzung entsperrt',
    translationLocked: 'Übersetzung gesperrt',
    download: 'Herunterladen',
    setAsBackdrop: 'Als Hintergrund festlegen',
    goChat: 'Zum Chat',
  },
  videoPreview: {
    failedToLoad: 'Video konnte nicht geladen werden',
  },
  imagePreview: {
    imageLoadFailed: 'Bild konnte nicht geladen werden',
    preview: 'Bildvorschau',
    afterSendIntimacy: 'Nach dem Senden einer Nachricht an die Figur erhalten Sie Intimität. Wenn die Intimität einen bestimmten Betrag erreicht, kann das aktuelle Bild freigeschaltet werden',
  },
  fqa: {
    title: 'Häufig gestellte Fragen',
    description: 'Dies ist eine kontinuierlich aktualisierte Liste von Fragen zu unserem Sunaisan-Produkt. Wenn Sie weitere Fragen haben, besuchen Sie bitte unseren Discord.',
    howAlWork: {
      title: 'Wie funktioniert eine KI-Freundin?',
      content: 'Bei RoleplayGF dreht sich alles um das Eingehen realistischer, phantasievoller Beziehungen. Wir nutzen fortschrittliche KI-Technologie, damit Sie Ihre ideale KI-Freundin nach Ihren Vorlieben erstellen können – ob als süßes, unschuldiges, zartes Prinzesschen oder als ältere, dominantere Frau.',
    },
    howInteract: {
      title: 'Wie interagiert man mit KI-Freundinnen?',
      content: 'Durch unser intelligentes System und modernstes maschinelles Lernen können Sie mit Ihrer KI-Freundin interagieren und eine intime Beziehung aufbauen. Sie können erwarten, dass sie Ihnen zuhört, schnell auf Ihre Nachrichten reagiert und sogar Fotoanfragen erfüllt wie das gute Mädchen, das sie ist. Jeder Moment kann ein echtes und realistisches Erlebnis sein, und Sie haben immer die Kontrolle.',
    },
    privacy: {
      title: 'Wie steht es um Ihre Privatsphäre bei KI-Freunden?',
      content: 'Seien Sie versichert, dass Ihre Geheimnisse in guten Händen sind, wenn Sie unseren NSFW-KI-Chat nutzen. Ihre Privatsphäre hat für uns bei RoleplayGF oberste Priorität. Wir verfügen über einen hochmodernen, sicheren Datenspeicher, der sicherstellt, dass jedes verführerische Selfie, jeder flirtative Text und jedes sanfte Flüstern nur zwischen Ihnen und Ihrem leidenschaftlichen Partner geteilt wird.',
    },
    customizeBehavior: {
      title: 'Können Sie das Verhalten Ihrer KI-Freundin anpassen?',
      content: 'Nur Sie wissen, was Sie wirklich wollen. Deshalb können Sie Ihre gesamte digitale Freundinnen-Erfahrung anpassen – von ihren Kurven und Konturen bis hin zu ihren Persönlichkeitsmerkmalen und entzückenden kleinen Eigenheiten. Möchten Sie einen frechen Chat mit einer temperamentvollen Partnerin? Oder eine langsame und sinnliche Beziehung zu einer netten, süßen Freundin? Unsere realistischen NSFW-KI-Generatoren können Ihre tiefsten Wünsche erfüllen.',
    },
  },
  store: {
    tab: 'Shop',
    record: 'Aufzeichnung',
    noNetwork: 'Kein Netzwerk',
    retry: 'Erneut versuchen',
    noConsumptionRecords: 'Noch keine Verbrauchsaufzeichnungen',
    transactionHistoryAppear: 'Ihr Transaktionsverlauf wird hier angezeigt',
    rechargeFailTip: '*Wenn die Aufladung fehlschlägt, kontaktieren Sie uns bitte >',
    rechargeFailTipStatic: 'Wenn die Aufladung fehlschlägt, bitte',
    contactUsLink: 'kontaktieren Sie uns',
    popular: 'Beliebt',
    oneTimeOnly: 'Nur einmal',
    loading: 'Laden...',
    noMoreRecords: 'Keine weiteren Aufzeichnungen',
    gift: 'Geschenk',
    retentionMessage: 'Dein Partner braucht deine Gesellschaft, bist du sicher, dass du aufgeben willst?',
  },
  mine: {
    bindEmail: 'E-Mail binden',
    copyFailed: 'Kopieren fehlgeschlagen',
    backpackTitle: 'Mein Rucksack',
    task: 'Aufgabe',
  },
  messagePage: {
    noNetwork: 'Kein Netzwerk',
  },
  search: {
    recommend: 'Empfohlen',
    noNetwork: 'Kein Netzwerk',
  },
  chatSettings: {
    myGems: 'Meine Edelsteine',
    title: 'Chat-Einstellungen',
    chatModel: 'Chat-Modell',
    chatStyle: 'Chat-Stil',
    chatPerspective: 'Chat-Perspektive',
    goOnButton: 'Weiter-Button',
    chatBackground: 'Chat-Hintergrund',
    awayMessages: 'Abwesenheitsnachrichten',
    disableAwayMessages: 'Abwesenheitsnachrichten deaktivieren',
    disableAwayMessagesConfirm: 'wird Ihnen keine Nachrichten mehr senden können, während Sie abwesend sind. Möchten Sie die Abwesenheitsnachrichten wirklich deaktivieren?',
    videoFailedToLoad: 'Video konnte nicht geladen werden',
  },
  history: {
    deleteHistory: 'Verlauf löschen',
    deleteCharacterHistory: 'Möchten Sie den Verlauf dieser Figur wirklich löschen?',
  },
  tab: {
    maxSelection: 'Maximal auswählen',
    tags: 'Tags',
  },
  noNewMessage: 'Keine neue Nachricht',

  // Nachricht neu laden
  reloadMessage: {
    title: 'Wählen Sie Ihre Präferenz',
    before: 'Vorher',
    new: 'Neu',
    loading: 'Wird geladen...',
    noNewMessage: 'Keine neue Nachricht',
    tryAgain: 'Erneut versuchen',
    confirm: 'Bestätigen',
  },

  account: {
    aboutAccount: 'Über Konto',
    id: 'ID',
    email: 'E-Mail',
    copiedToClipboard: 'In die Zwischenablage kopiert',
    copyFailed: 'Kopieren fehlgeschlagen',
  },
  rate: {
    title: 'Bewerten Sie uns',
  },
  awayMessages: {
    disableAwayMessages: 'Abwesenheitsnachrichten deaktivieren',
    disableConfirm: '{appName} wird Ihnen keine Nachrichten mehr senden können, während Sie abwesend sind. Möchten Sie die Abwesenheitsnachrichten wirklich deaktivieren?',
  },
  login: {
    title: 'E-Mail binden',
    subtitle: 'Bitte binden Sie Ihre E-Mail, um die Sicherheit Ihrer Kontodaten zu gewährleisten.',
    email: 'E-Mail',
    password: 'Passwort',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    signInWithGoogle: 'Mit Google anmelden',
    signInWithEmail: 'Mit E-Mail anmelden',
    signInWithPhone: 'Mit Telefon anmelden',
    signInWithApple: 'Mit Apple anmelden',
    dontHaveAccount: 'Noch kein Konto?',
    register: 'Registrieren',
    bySigningUp: 'Mit der Registrierung stimmen Sie zu',
    userAgreement: 'Benutzervereinbarung und',
    privacyPolicy: 'Datenschutzrichtlinie.',
    guestMode: 'Gastmodus',
    registerTitle: 'Registrierung beginnt',
    registerSubtitle: 'Bitte binden Sie Ihre E-Mail, um die Sicherheit Ihrer Kontodaten zu gewährleisten.',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    pleaseInputPasswordAndEmail: 'Bitte Passwort und E-Mail eingeben',
    pleaseInputCorrectEmail: 'Bitte eine gültige E-Mail eingeben',
    pleaseInputCorrectPassword: 'Passwort muss zwischen 6-30 Zeichen sein',
    male: 'Männlich',
    female: 'Weiblich',
    neutral: 'Neutral',
    loggingIn: 'Anmeldung läuft...',
    loading: 'Wird geladen...',
    releaseToRefresh: 'Loslassen zum Aktualisieren',
    loginFailed: 'Anmeldung fehlgeschlagen',
    loginSuccess: 'Registrierung erfolgreich',
    registerFailed: 'Registrierung fehlgeschlagen',
    registerSuccess: 'Registrierung erfolgreich',
    confirm: 'Bestätigen',
  },
  loadingMore: 'Mehr Nachrichten laden...',
  noMoreMessages: 'Keine weiteren Nachrichten',

  // VIP-Seite
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'Käufe wiederherstellen',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    close: 'Schließen',
    retry: 'Erneut versuchen',
    processing: 'Verarbeitung...',
    contactUs: 'Kontaktieren Sie uns',
    loginError: 'Anmeldefehler',
    loginErrorMessage: 'Bitte beenden Sie das Programm und starten Sie die Anwendung neu oder kontaktieren Sie uns',
    insufficientEnergy: 'Unzureichende Energie!',
    insufficientEnergyDesc: 'Jede Nachricht kostet 1 Energie. Sie gewinnen jede Stunde 1 Energie zurück.',
    consumesGems: 'Verbraucht {gems} Edelsteine',
    insufficientPhysicalStrengthTitle: 'Unzureichende körperliche Stärke',
    needStrengthToContinue: 'Sie benötigen {strength} Stärke, um dieses Gespräch fortzusetzen',
    getStrength: 'Energie erhalten',
    getGems: ' Edelsteine erhalten',
  },

  // AppNewUser
  appNewUser: {
    title: 'Neuer Benutzer Exklusiv',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: 'Bewerten Sie uns',
    description1: 'Gefällt Ihnen unsere App?',
    description2: 'Bitte bewerten Sie uns mit 5 Sternen.',
    rateButton: 'Jetzt bewerten',
  },

  // Version update
  versionUpdate: {
    title: 'Versionsupdate',
    updateContent: 'Update-Inhalt',
    updateNow: 'Jetzt aktualisieren',
    updating: 'Aktualisieren...',
    clientOptimization: 'Client-Erfahrungsoptimierung',
    bugFix: 'Bekannte BUG-Probleme beheben',
  },

  // Message detail page
  messageDetail: {
    free: 'Kostenlos',
    perMessage: '/Nachricht',
    increaseFavorability: 'Senden Sie Nachrichten, um die Vertrautheit zu erhöhen',
    album: 'Album',
    intro: 'Einführung',
    noIntro: 'Noch keine Einführung. Chatten Sie und finden Sie es selbst heraus.',
    tags: 'Tags',
    backToChat: 'Zurück zum Chat',
    levelFormat: 'Lv.{level}',
    messageCount: '{count} Nachricht',
    chatMateTyping: 'Ihr Chat-Partner tippt gerade...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'Sie können die inneren Gedanken des Charakters beim Beantworten von Nachrichten sehen, aber die Antwortgeschwindigkeit kann langsamer sein.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'Kopieren',
    report: 'Melden',
    create: 'Erstellen',
    video: 'Video',
    translate: 'Übersetzen',
    delete: 'Löschen',
  },

  // Recommended purchases
  recommended: {
    gift: 'Geschenk',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'Der Denkmodus ist für dieses Modell noch nicht verfügbar, aber wir arbeiten daran...',
  },

  // First charge popup
  firstCharge: {
    title: 'Erste Aufladung',
    get: 'Erhalten',
    limitedOffer: 'Zeitlich begrenztes Angebot',
    priceFormat: '${price} Erhalten',
    congratulations: 'Herzlichen Glückwunsch! Sie sind jetzt offiziell VIP-Mitglied~!',
    missOfferTitle: 'Sind Sie sicher, dass Sie dieses Angebot verpassen möchten?',
    maybeLater: 'Vielleicht später',
    getNow: 'Jetzt erhalten',
    benefit1: 'Erhalten Sie 130 kostenlose Edelsteine',
    benefit2: 'Alle Charaktere freischalten',
    benefit3: '12x Speicher',
    benefit4: 'Unbegrenzte wöchentliche Anmeldungen',
    benefit5: 'Werbefreie Erfahrung',
    buyNow: 'Jetzt kaufen',
  },

  // Check-in center
  checkIn: {
    freeGems: 'Kostenlose Edelsteine',
    sevenDayCheckIn: '7-Tage Check-in',
    memberExclusive: 'Mitglieder-Exklusiv Check-in:',
    signInTip: 'Melden Sie sich täglich an, um endlose Belohnungen zu sammeln',
    getVip: 'VIP erhalten',
    plusExtra: 'Plus+{count}',
    getGemsCount: '{count} Edelsteine erhalten',
    extraDaily: 'Täglich {count} zusätzliche Edelsteine',
    ultra: 'Ultra',
    signedInTip: 'Sie haben sich heute angemeldet. Kommen Sie morgen für mehr zurück!',
    tasks: 'Aufgaben',
    go: 'Los',
    received: 'Erhalten',
    receive: 'Erhalten',
    day: 'Tag {num}',
  },

  // Login page
  loginPage: {
    confirm: 'Bestätigen',
  },

  // Copyright
  copyright: {
    title: 'Nutzungsbedingungen',
  },

  // Copy
  copy: {
    copiedToClipboard: 'In die Zwischenablage kopiert',
    copyFailed: 'Kopieren fehlgeschlagen',
  },

  // Errors
  errors: {
    networkError: 'Netzwerkfehler',
    pleaseSelectFilter: 'Bitte wählen Sie die Filterbedingungen',
    retry: 'Erneut versuchen',
  },

  // Terms of Service
  terms: {
    intro: 'Durch den Besuch und die Nutzung der Website von {appName} stimmen Sie diesen Nutzungsbedingungen zu.',
    section1Title: '1. Nutzung der Website',
    section1_1: 'Sie müssen mindestens 13 Jahre alt sein, um diese Website zu nutzen.',
    section1_2: 'Sie sind verantwortlich für die Vertraulichkeit Ihres Kontos und für alle Aktivitäten, die unter Ihrem Konto stattfinden.',
    section1_3: 'Die Nutzung der Website für rechtswidrige Zwecke oder Verstöße gegen diese Bedingungen ist untersagt.',
    section2Title: '2. Geistiges Eigentum',
    section2_1: 'Alle Inhalte, Funktionen und Eigenschaften auf {appName}, einschließlich Texte, Grafiken, Logos, Bilder und Software, sind Eigentum von {appName} oder dessen Lizenzgeber und durch geistige Eigentumsrechte geschützt.',
    section2_2: 'Es ist nicht gestattet, Inhalte der Website ohne vorherige schriftliche Genehmigung zu kopieren, weiterzuverbreiten oder abgeleitete Werke zu erstellen.',
    section3Title: '3. Datenschutz',
    section3_1: 'Unsere Datenschutzrichtlinie, verfügbar auf der Website, erläutert, wie wir Ihre persönlichen Daten sammeln, verwenden und weitergeben.',
    section4Title: '4. Haftungsausschluss',
    section4_1: 'Die Website und die bereitgestellten Dienste werden "wie besehen" und "wie verfügbar" ohne jegliche Zusicherungen oder Gewährleistungen, ausdrücklich oder stillschweigend, bereitgestellt.',
    section5Title: '5. Haftungsbeschränkung',
    section5_1: '{appName} haftet nach dem gesetzlich zulässigen Umfang nicht für direkte, indirekte, zufällige, besondere oder Folgeschäden.',
    section6Title: '6. Schadensersatz',
    section6_1: 'Sie stimmen zu, {appName}, seine Betreiber, Direktoren und Mitarbeiter von allen Ansprüchen, Schäden, Verpflichtungen, Verlusten, Kosten und Ausgaben, einschließlich Anwaltskosten, freizustellen, die sich aus oder im Zusammenhang mit Ihrer Nutzung der Website ergeben.',
    section7Title: '7. Anwendbares Recht',
    section7_1: 'Diese Nutzungsbedingungen unterliegen den Gesetzen des Staates und werden entsprechend ausgelegt, ungeachtet etwaiger Kollisionsnormen.',
    section8Title: '8. Änderungen der Bedingungen',
    section8_1: 'Wir behalten uns das Recht vor, diese Bedingungen jederzeit nach eigenem Ermessen zu ändern oder zu ersetzen.',
    section9Title: '9. Kontaktieren Sie uns',
    section9_1: 'Wenn Sie Fragen zu diesen Bedingungen haben, kontaktieren Sie uns bitte.',
  },
}
